module.exports = __webpack_public_path__ + "static/img/production5.708ebe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/production5.png
// module id = 64FM
// module chunks = 2